import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';

import { BciSidebarService, SidebarNavItem } from '@bci-web-core/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';	import { SystemPrivacyModalComponent } from '../user/system-privacy-modal/system-privacy-modal.component';							  
import { DataService } from 'src/app/services/data.service';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService, Constants } from 'src/app/shared/index';
import { CommonService } from 'src/app/services/index';
import { AccountModel, AuthUserInfo } from 'src/app/models/index';
import { AuthGuard } from 'src/app/shared/index';
import { AppComponent } from 'src/app/app.component';
import { SiteService } from 'src/app/services/site.service';
import { AdalService } from 'adal-angular4';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [DataService]
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
  model: AccountModel = new AccountModel();
  captchaUrl = '';
  constructor(
    private router: Router,
    private sidebarService: BciSidebarService,
    private alert: AlertService,
    public auth: AuthGuard,
    private dataService: DataService,
    private siteService: SiteService,
    private authService: AuthService,
    private appComponent: AppComponent,
    private commonService: CommonService,
    private adalService: AdalService,
	public dialog: MatDialog
  ) {
  }

  sidebarLinksAdmin: SidebarNavItem[] = [
  ];
  sidebarLinksUser: SidebarNavItem[] = [
  ];

  ngOnInit() {
    // this.adalService.handleWindowCallback();
    this.sidebarService.setSidebarVisibility(false);
    // this.captchaUrl = Constants.GetCaptchaUrl(); Update Later
  }

  ngAfterViewInit() {
    this.sidebarService.setSidebarVisibility(false);
  }
  get authenticated(): boolean {
    return this.adalService.userInfo.authenticated;
  }
  login() {
    
    if (!this.authenticated) {
      this.adalService.login();
    }
    // this.authService.login(this.model.userName, this.model.password).subscribe(data => {
    //   if (data != null) {
    //     const tmpAuthUser = new AuthUserInfo(data.access_token);
    //     localStorage.setItem('currentUser', JSON.stringify(tmpAuthUser));
    //     this.authService.getUserDetail().subscribe(userInfo => {
    //       if (userInfo !== null) {
    //         let fullName = '';

    //         const firstName = !this.commonService.isNullOrUndefined(userInfo.data.firstName) ? userInfo.data.firstName : '';
    //         const lastName = !this.commonService.isNullOrUndefined(userInfo.data.lastName) ? userInfo.data.lastName : '';
    //         if (firstName !== '' && lastName !== '') {
    //           fullName = firstName + ' ' + lastName;
    //         }

    //         const authUser = new AuthUserInfo(data.access_token, data.refresh_token, data.token_type,
    //           userInfo.data.username, fullName, userInfo.data.role, userInfo.data.flatMenus, data.expires_at,
    //           userInfo.data.useSSO, userInfo.data.activities);
    //         localStorage.setItem('currentUser', JSON.stringify(authUser));
    //         this.authService.userActivities = userInfo.data.activities;
    //         this.authService.userRole = userInfo.data.role.name;

    //         this.authService.userMenus = userInfo.data.flatMenus;
    //         const menu = [];
    //         const sidebarLinksUser: SidebarNavItem[] = this.authService.buildMenus(this.authService.defaultMenus, menu, true);

    //         this.auth.sidebarLinks = sidebarLinksUser;
    //         this.appComponent.sidebarFooterLinks[0].title = authUser.fullName !== '' ? authUser.fullName : authUser.userName;

    //         this.siteService.getSiteDetails().subscribe(sites => {

    //           if (sites.length > 1) {
    //             this.router.navigate(['/site-master']);
    //           } else if (sites.length === 1) {

    //             const find = this.auth.sidebarLinks.find((c: any) => c.code === 'HOME');
    //             if (!this.commonService.isNullOrUndefined(find)) {
    //               find.url = '/site' ;
    //               localStorage.setItem('siteId', sites[0].siteId );
    //             }
    //             this.router.navigate(['/site'], { queryParams: { siteId: sites[0].siteId } });
    //           }
    //         });
    //       }
    //     });

    //   } else {
    //     this.alert.message = Constants.MESSAGE.LoginFail;
    //     this.alert.showSuccess();
    //   }
    // });

  }

  ngOnDestroy() {
    this.sidebarService.setSidebarVisibility(true);
  }

}
